import { END_POINTS } from "../constants/url";

import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
  data: any;
};

export const AnalyticsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getGraph: builder.query<
      CommonResponseType & { data: any },
      {
        type: number;
      }
    >({
      query: ({ type }) => ({
        url: `${END_POINTS.analytics}?type=${type}`,
        method: "GET",
      }),
    }),
  }),
});
export const { useLazyGetGraphQuery } = AnalyticsApi;
